import React from "react";
import styled from "styled-components";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";

const TriggerWapper = styled.div`
    display: flex;
    align-items: end;
    gap: 6px;
`;
// adding verifed statues
const CheckWapper = styled.button`
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    background: #e6f9f7;
    border: ${(props) => (props.verifed ? "2px solid #016778" : "none")};
`;
const ClearWapper = styled.button`
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    background: #f8e9e9;
    border: ${(props) => (props.objection ? "2px solid #bd271e" : "none")};
`;
const VerifyComponent = ({ objectionHandler, handleVerify, verifed, objection }) => (
    <TriggerWapper>
        <CheckWapper
            onClick={handleVerify}
            verifed={verifed}
        >
            <CheckIcon style={{ color: "#016778" }} />
        </CheckWapper>
        <ClearWapper
            onClick={objectionHandler}
            objection={objection}
        >
            <ClearIcon style={{ color: "#BD271E" }} />
        </ClearWapper>
    </TriggerWapper>
);

export default VerifyComponent;
